// extracted by mini-css-extract-plugin
module.exports = {"modal":"MyIpDetailModal_modal__1Pl3w","body":"MyIpDetailModal_body__gP9_g"};